import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBgpError = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 99,
	height: 99,
	viewBox: "0 0 99 99",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M49.5 33v20.625",
			stroke: "#9e2929",
			strokeWidth: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M49.5 70.125a4.125 4.125 0 1 0 0-8.25 4.125 4.125 0 0 0 0 8.25Z",
			fill: "#9e2929"
		}),
		/* @__PURE__ */ _jsx("path", {
			clipRule: "evenodd",
			d: "M49.5 90.75c22.782 0 41.25-18.468 41.25-41.25S72.282 8.25 49.5 8.25 8.25 26.718 8.25 49.5 26.718 90.75 49.5 90.75Z",
			stroke: "#9e2929",
			strokeWidth: 3
		})
	]
});
export default SvgBgpError;
